export default from './ChatPage';



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/MobileMessages/components/ChatPage/index.js